import { Web3ReactProvider } from '@web3-react/core'
import { providers } from 'ethers'
import { AppLayout, ClaimInterface, ConnectInterface } from './components'

export const App = () => {
  function getLibrary(provider: providers.ExternalProvider) {
    return new providers.Web3Provider(provider)
  }
  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <AppLayout>
        <ConnectInterface />
        <ClaimInterface />
      </AppLayout>
    </Web3ReactProvider>
  )
}
